import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";

import { ssoGroupsMappingText } from "../../../../assets/texts/Settings/sso";
import { cyIds } from "./SsoGroupMappingList";

type SsoAddMappingButtonProps = {
  onAdd: () => void;
  disabled?: boolean;
};

/**
 * Button to add a new mapping to the SSO group mapping list.
 * This button is a little different in that it is designed to sit visually <em>below</em> its parent stack and off to the right hand side when the app is above the md width breakpoint.
 * This will nestle it nicely "into" the header row provided by {@link SsoGroupMappingHeaders}.
 * When the app width is below the md breakpoint, the button will sit flush within its parent stack, and above the draggable item area provided in {@link SsoGroupMappingList}.
 * @param onAdd - The function to call when the button is clicked.
 * @param disabled - Whether the button should be disabled.
 * @returns A button to add a new mapping to the SSO group mapping list.
 */
const SsoAddMappingButton = ({ onAdd, disabled = false }: SsoAddMappingButtonProps) => (
  <Stack
    direction="row"
    sx={(theme) => ({
      height: 0,
      position: "relative",
      width: "100%",
      [theme.breakpoints.down("md")]: {
        height: "auto",
        mb: 3,
      },
    })}
  >
    <Button
      startIcon={<AddIcon />}
      onClick={onAdd}
      data-cy={cyIds.buttons.add}
      variant="outlined"
      disabled={disabled}
      sx={(theme) => ({
        width: "fit-content",
        ml: "auto",
        position: "absolute",
        right: 0,
        top: 0,
        [theme.breakpoints.down("md")]: {
          position: "static",
          ml: 0,
        },
      })}
    >
      {ssoGroupsMappingText.BUTTON_ADD_MAPPING}
    </Button>
  </Stack>
);

export default SsoAddMappingButton;
